module.exports = __webpack_public_path__ + "static/media/3.6485d976.png";